import { put, takeLatest } from 'redux-saga/effects';

import Api, { callApi } from 'domain/api';
import { addNotification } from 'domain/env';
import { actions } from 'domain/customer';

function* registerUserSaga(action) {
  try {
    const { resolve, reject, ...data } = action.payload;
    const response = yield callApi(Api.registerUser, { data });

    yield put({
      type: actions.registerUserAction.success,
      payload: response.data,
    });

    yield put(
      addNotification({
        type: 'success',
        title: 'User registered successfully!',
      })
    );

    if (resolve) {
      resolve(response);
    }

    return response;
  } catch (error) {
    const { reject } = action.payload;
    yield put({
      type: actions.registerUserAction.failure,
      payload: error,
    });

    yield put(
      addNotification({
        type: 'error',
        title: error.response?.data?.message || 'Registration failed',
      })
    );

    if (reject) {
      reject(error);
    }

    throw error;
  }
}

export default function* customerSignUpSaga() {
  yield takeLatest(actions.registerUserAction.type, registerUserSaga);
}
